var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9755 10.6296L11.198 9.3974V9.398C10.7679 8.71818 9.84766 8.5024 9.14253 8.91714L8.50039 9.29401C8.31024 9.40822 8.06397 9.38357 7.90188 9.23451C6.87382 8.25896 6.11322 7.05254 5.6874 5.72429C5.62693 5.51691 5.71795 5.29633 5.90997 5.18572L6.55211 4.80945L6.55149 4.80885C7.25723 4.3941 7.48042 3.50692 7.05024 2.82708L6.27218 1.59487C5.84201 0.915043 4.92181 0.699863 4.21667 1.114L2.97664 1.8383C2.53025 2.09676 2.25719 2.56199 2.25781 3.06389C2.25719 5.19646 2.86381 7.28825 4.01088 9.11137C5.16364 10.92 6.802 12.3945 8.75281 13.379C8.97164 13.4896 9.2154 13.5479 9.46291 13.5485C9.73597 13.5485 10.0041 13.4757 10.2372 13.3387L11.476 12.6114C12.1811 12.1966 12.4043 11.3095 11.9748 10.6296L11.9755 10.6296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterCall);
export default __webpack_public_path__ + "static/media/footerCall.8ccb77816e9f4efbf8e52cb0bf3e05dd.svg";
export { ForwardRef as ReactComponent };